import React, { type ReactNode } from 'react';

import IconClose from '@pkg/assets/icons/close.svg?react';
import { type CommonActionProps } from '@pkg/primitives';

import { Action, Badge, BadgeLabel, IconWrapper, Label } from './FilterChip.style';

export interface FilterChipProps {
    label: string;
    icon?: ReactNode;
    badge?: string | number;
    ariaLabel?: string;
    variant?: 'toggle' | 'dismiss';
    disabled?: boolean;
    pressed?: boolean;
    children?: ReactNode;
    onAction?: CommonActionProps['onAction'];
}

export function FilterChip({
    label,
    icon,
    badge,
    ariaLabel,
    variant = 'toggle',
    disabled = false,
    pressed = false,
    children,
    onAction,
}: FilterChipProps) {
    const isToggle = variant === 'toggle';
    const ariaLabelFallback = isToggle ? 'Toggle this filter' : 'Remove this filter';

    const iconMarkup = icon ? <IconWrapper>{icon}</IconWrapper> : null;
    const badgeMarkup =
        badge === undefined ? null : (
            <Badge>
                <BadgeLabel>{badge}</BadgeLabel>
            </Badge>
        );

    const closeMarkup = isToggle ? null : (
        <IconWrapper>
            <IconClose />
        </IconWrapper>
    );

    return (
        <Action
            $variant={variant}
            ariaLabel={ariaLabel || ariaLabelFallback}
            disabled={disabled}
            pressed={pressed && isToggle}
            onAction={onAction}
        >
            {iconMarkup}
            <Label>{label}</Label>
            {badgeMarkup}
            {children}
            {closeMarkup}
        </Action>
    );
}
